import { useMemo } from 'react'
import styled from 'styled-components'
import { useTree } from '@/api/hooks/useTree'
import { layerChangeEvent } from '@/components/layout/AppBar/search/SearchItem'
import useResponsive from '@/hooks/useResponsive'
import  IconBack from '@/components/icons/IconBack'
import { useGlobalStore } from '@/stores/globalStore';


export const BackButton = () => {
  const { layers } = useTree()
  const { activeLayer, setActiveLayer } = useGlobalStore()
  const { nodes } = layers || {}
  const current = useMemo(
    () => nodes?.find(node => node.id == activeLayer),
    [nodes, activeLayer],
  )
  const { isPhone } = useResponsive()

  const handleLayerChange = () => {
    if (!current || !current.parent) return
    document.dispatchEvent(layerChangeEvent(current.parent))

    setActiveLayer(Number(current.parent))
  }

  if (!current || !current.parent) {
    return !isPhone ? <div /> : null
  }

  return (
    <Item onClick={handleLayerChange}>
      <IconBack />
      {!isPhone ? <p>Назад</p> : null}
    </Item>
  )
}

const Item = styled.div`
  flex-shrink: 0;
  height: 52px;
  display: flex;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 16px;
  position: relative;
  transition: background 0.3s, color 0.3s;

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    margin-left: 8px;
    color: #2F323C;
  }

  background: #fff;
  border: 1px solid #2F323C;
`
